import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import styled from "styled-components";

import Image from "components/atoms/Image";
import Button from "components/atoms/button/Button";
import StyledText from "components/atoms/text/StyledText";

import { apiUrl } from "utils/urls";

import axios from "axios";
import moment from "moment";

const Container = styled.div`
    width: 100%;
    height: 100%;
    max-height: 80vh;
    overflow-y: auto;
`;

// 전체 모달 컨테이너
const ModalContent = styled.div`
    width: 100%;

    @media print {
        padding: 20px;
    }
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${(props) => props.justifyContent || "space-between"};
    align-items: ${(props) => props.alignItems || "flex-start"};
    margin: ${(props) => props.margin || "16px 0 0 0"};
    height: auto;
    width: 100%;
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: var(--color-Line);
    margin: 24px 0;
`;

const PaymentTitleText = styled(StyledText)`
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--color-SubBlack);
`;

const PaymentAmountText = styled(StyledText)`
    font-size: 1.4rem;
    color: var(--color-SubBlack);
`;

const TitleText = styled(StyledText)`
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-SubBlack);
`;

const ContentText = styled(StyledText)`
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-SubBlack);
`;

const PaymentInfoBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    background-color: var(--color-InfoBox);
    border-radius: 2px;
    padding: 12px;
    margin-top: 16px;
`;

const PaymentInfoBoxRow = styled(Row)`
    margin: 0;
`;

const PaymentInfoBoxTitleText = styled(TitleText)``;

const PaymentInfoBoxSubTitleText = styled(StyledText)`
    margin: 8px 0 0 0;
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

const PaymentInfoBoxContentText = styled(ContentText)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

const SmallText = styled(StyledText)`
    margin: 0;
    font-size: 1.2rem;
    text-align: ${(props) => props.textAlign || "right"};
    line-height: 1.4;
    color: var(--color-Grey1);
`;

const PaymentBillingHistoryModal = (props) => {
    const [paymentReceipt, setPaymentReceipt] = React.useState(null);
    const printRef = useRef();

    const getPaymentReceipt = () => {
        axios
            .get(apiUrl("paymentBillingReceipt"), {
                params: { id: props.id },
            })
            .then((res) => {
                setPaymentReceipt(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (props) {
            getPaymentReceipt();
        }
    }, [props]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        onAfterPrint: () => console.log("Print job completed!"),
    });

    const totalAmount =
        (paymentReceipt?.subscription_price || 1) *
        (paymentReceipt?.target_month || 1) *
        (paymentReceipt?.group?.max_member || 1);

    return (
        <Container>
            <ModalContent ref={printRef}>
                <Row>
                    <Image name={"headerLogo"} />
                    <SmallText>
                        (주) 데이탄소프트
                        <br />
                        제주특별자치도 제주시 도령북길 31, 2층
                        <br />
                        prep@datansoft.com
                    </SmallText>
                </Row>

                <Divider />

                <Row>
                    <PaymentTitleText>총 결제 금액</PaymentTitleText>
                    <PaymentAmountText>₩{paymentReceipt?.amount.toLocaleString("ko-KR")}</PaymentAmountText>
                </Row>

                <PaymentInfoBox>
                    <PaymentInfoBoxRow>
                        <div>
                            <PaymentInfoBoxTitleText>
                                {paymentReceipt?.subscription_name} {paymentReceipt?.target_month}개월 이용 요금
                            </PaymentInfoBoxTitleText>
                            <PaymentInfoBoxSubTitleText>
                                이용 기간: {moment(paymentReceipt?.started_at).format("YYYY.MM.DD")} ~{" "}
                                {moment(paymentReceipt?.ended_at).format("YYYY.MM.DD")}
                            </PaymentInfoBoxSubTitleText>
                            {paymentReceipt?.group?.max_member && (
                                <PaymentInfoBoxSubTitleText>
                                    인원: {paymentReceipt?.group.max_member}명
                                </PaymentInfoBoxSubTitleText>
                            )}
                            <PaymentInfoBoxSubTitleText></PaymentInfoBoxSubTitleText>
                        </div>
                        <PaymentInfoBoxContentText>₩{totalAmount.toLocaleString("ko-KR")}</PaymentInfoBoxContentText>
                    </PaymentInfoBoxRow>
                    {paymentReceipt?.target_month === 3 && (
                        <PaymentInfoBoxRow>
                            <PaymentInfoBoxTitleText>장기 결제 할인</PaymentInfoBoxTitleText>
                            <PaymentInfoBoxContentText>
                                - ₩{(totalAmount * 0.1).toLocaleString("ko-KR")}
                            </PaymentInfoBoxContentText>
                        </PaymentInfoBoxRow>
                    )}
                    {paymentReceipt?.group?.max_member && (
                        <PaymentInfoBoxRow>
                            <PaymentInfoBoxTitleText>그룹 결제 할인</PaymentInfoBoxTitleText>
                            <PaymentInfoBoxContentText>
                                - ₩{(totalAmount * 0.1).toLocaleString("ko-KR")}
                            </PaymentInfoBoxContentText>
                        </PaymentInfoBoxRow>
                    )}
                </PaymentInfoBox>

                <Row margin={"12px 0 0 0"}>
                    <SmallText textAlign={"left"}>표시된 모든 금액은 부가세(VAT)가 포함된 금액입니다.</SmallText>
                </Row>
                <Divider />
                {paymentReceipt?.payment_status !== "bill" && (
                    <Row>
                        <TitleText>결제번호</TitleText>
                        <ContentText>{paymentReceipt?.merchant_uid}</ContentText>
                    </Row>
                )}

                <Row>
                    <TitleText>결제일</TitleText>
                    <ContentText>
                        {paymentReceipt?.payment_status === "bill"
                            ? moment(paymentReceipt?.created_at).format("YYYY.MM.DD")
                            : moment(paymentReceipt?.created_at).format("YYYY.MM.DD HH:mm:ss")}
                    </ContentText>
                </Row>
                <Row>
                    <TitleText>결제 상태</TitleText>
                    <ContentText>
                        {paymentReceipt?.payment_status === "refund"
                            ? "결제 취소"
                            : paymentReceipt?.payment_status === "bill"
                            ? "결제 예정"
                            : "결제 완료"}
                    </ContentText>
                </Row>
                <Row>
                    <TitleText>결제 수단</TitleText>
                    <ContentText>
                        {paymentReceipt?.billing_key?.card_name} {paymentReceipt?.billing_key?.card_number}
                    </ContentText>
                </Row>
                <Divider />
                <Row margin={"40px 0 60px 0"}>
                    <TitleText>
                        위의 결제 금액을{" "}
                        {paymentReceipt?.payment_status === "refund"
                            ? "환불하였습니다."
                            : paymentReceipt?.payment_status === "bill"
                            ? "청구합니다."
                            : "영수하였습니다."}
                    </TitleText>
                    <SmallText>계정: {props.user?.email}</SmallText>
                </Row>
            </ModalContent>
            <Row margin={"0 0 0 0"} justifyContent={"center"}>
                <Button
                    onlyText
                    onClick={handlePrint}
                    margin={""}
                    width={"160px"}
                    height={"40px"}
                    bgColor={"var(--color-Button2)"}
                    hoverBgColor={"var(--color-ButtonHover2)"}
                    fontColor={"var(--color-White)"}
                    buttonText={"인쇄"}
                />
            </Row>
        </Container>
    );
};

export default PaymentBillingHistoryModal;
